const namespace = 'ui-search-billboard';
const namespaceMobile = 'ui-search-billboard-intervention';

export { namespace, namespaceMobile };
